// extracted by mini-css-extract-plugin
module.exports = {"sendPanel":"ntc_sendPanel__aeWet","typeSelect":"ntc_typeSelect__AHQkl","subscriptionMenu":"ntc_subscriptionMenu__5a2Fr"};